window.initHomeHero = (options = {
    allGamesLink
}) => {
    var mySwiperHero = new Swiper('.hero-swiper', {
        // Optional parameters
        // spaceBetween: 50,
        loop: true,
        simulateTouch: false,
        init: false,

        effect: "fade",
        fadeEffect: {
            crossFade: true
        },

        lazy: {
            loadPrevNext: true,
            elementClass: 'swiper-lazy-mobile'
        },
        autoplay: false,

        speed: 700,
        // Navigation arrows
        navigation: {
            nextEl: '.hero-swiper-button--next',
            prevEl: '.hero-swiper-button--prev',
        },
        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + '</span>';
            },
        },
        breakpoints: {
            1025: {
                lazy: {
                    loadPrevNext: true,
                    elementClass: 'swiper-lazy'
                }
            }
        }
    });

    window.addEventListener("load", (event) => {
        if (!mySwiperHero.autoplay.running) {
            mySwiperHero.params.autoplay = {
                delay: 5700,
            };
            mySwiperHero.autoplay.start();
        } 
    });

    setTimeout(() => {
        mySwiperHero.init();
    }, 500);
}
